// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3iE5X","label":"Category_label__3BoSV","content":"Category_content__2KTGZ","header":"Category_header__MqknD","location":"Category_location__2Hrbn"};